/**
 * Created with IntelliJ IDEA.
 * User: comoom
 * Date: 14-1-10
 * Time: 上午9:25
 * To change this template use File | Settings | File Templates.
 */

let $ = require("jquery");
let _ = require("underscore");
let Backbone = require("backbone");

let main = function () {
    var recorder = (function () {
        var DbRecorder = {};
        var self = DbRecorder;
        var stores = {};
        var defaultOptions = {detailed: true, type: "model"};
        var status = new Backbone.Model({online: true, websocketOnline: false});
        var printRecordQueue = new Backbone.Collection();


        window.addEventListener("offline", function (e) {
            DbRecorder.setOffline();
        }, false);
        window.addEventListener("online", function (e) {
            DbRecorder.setOnline();
        }, false);

        DbRecorder.setOnline = function () {
            if (!status.get("online")) {
                console.log(new Date() + " system has gone online");
            }
            status.set({online: true});
        };
        DbRecorder.setOffline = function (restaurantId) {
            if (status.get("online")) {
                console.log(new Date() + " system has gone offline");
            }
            status.set({online: false});
            //Raven.captureMessage("offline error");
        };
        DbRecorder.setWebSocketOnline = function () {
            if (!status.get("websocketOnline")) {
                console.log(new Date() + " websocket has gone online");
            }
            status.set({websocketOnline: true});
        };
        DbRecorder.setWebSocketOffline = function (restaurantId) {
            if (status.get("websocketOnline")) {
                console.log(new Date() + " websocket has gone offline");
            }
            status.set({websocketOnline: false});
            //Raven.captureMessage("websocketOffline error",{extra: {restaurantId: restaurantId}});
        };
        DbRecorder.getStatus = function () {
            return status.toJSON();
        };
        DbRecorder.getStatusModel = function () {
            return status;
        };

        DbRecorder.getPrintRecordQueue = function () {
            return printRecordQueue;
        };

        DbRecorder.recordPrintQueue = function (bill, printType) {
            printRecordQueue.add({bill: bill, printType: printType});
        };

        /**
         * convert2JSON方法是一个深度的Model和collection toJSON的方法
         * 可以让model或者collection属性为model或者collection的仍然执行convert2JSON方法
         * 直到Object中不包含model或者collection
         * @param object
         * @returns {*}
         */
        DbRecorder.convert2JSON = function (object) {
            if (!(_.isArray(object)) && !(_.isObject(object))) {
                return object;
            } else if (_.isArray(object)) {
                return _.map(object, function (o) {
                    return self.convert2JSON(o)
                })
            } else if (_.isObject(object)) {
                if (object instanceof Backbone.Model) {
                    return self.convert2JSON(object.toJSON());
                } else if (object instanceof Backbone.Collection) {
                    return self.convert2JSON(object.toJSON());
                } else {
                    var newObject = {};
                    _.each(object, function (v, k) {
                        newObject[self.convert2JSON(k)] = self.convert2JSON(v);
                    });
                    return newObject;
                }
            } else {
                return object.toString();
            }
        };

        /**
         * 因为chromeAppId之前已经被其他地方多次调用
         * 所以这里判断如果key是chromeAppId，则返回chrome store插件id，在开发环境中，可以修改此值
         * @param key
         * @returns {*}
         */
        DbRecorder.read = function (key) {
            if (key == "chromeAppId") {
                return storage.getItem(key) || "icljnpoeofbkpjhpbihhflgedmlcfoeh";
            } else {
                return storage.getItem(key);
            }
        };

        DbRecorder.remove = function (key) {
            storage.removeItem(key);
        };

        /**
         * 寻找对象中所有的model和collection
         * @param model
         * @returns {Array}
         */
        DbRecorder.search = function (model) {
            var object, subs = [];
            if (!(model instanceof Backbone.Model) && !(model instanceof Backbone.Collection)) {
                // 如果object不是Model或者Collection
                if (_.isUndefined(object) || _.isEmpty(object) || _.isString(object) || _.isNumber(object)) {
                    return subs;
                }
                if (_.isFunction(model)) {
                    return subs;
                }
                if (_.isElement(model)) {
                    return subs
                }
                //如果Model是Array，或者map，则准备循环处理Array中的每一个Elem
                if (_.isArray(model) || _.isObject(model)) {
                    object = model;
                }
            } else {
                // 如果object是model或collection， 则先将object放到结果集合，
                // 然后准备循环处理其中的每个属性（collection中的没一个model）
                subs.push(model);
                object = model.attributes || model.models;
            }

            // 循环处理objects
            _.each(object, function (v) {
                if (v instanceof Backbone.Model) {
                    // 处理model
                    subs = subs.concat(self.search(v));
                } else if (v instanceof Backbone.Collection) {
                    // 处理collection
                    subs = subs.concat(self.search(v));
                } else if (_.isArray(v)) {
                    // 处理array
                    _.each(v, function (vs) {
                        subs = subs.concat(self.search(vs));
                    });
                } else if (_.isObject(v)) {
                    // 处理map
                    _.each(v, function (vs, key) {
                        subs = subs.concat(self.search(key));
                        subs = subs.concat(self.search(vs));
                    });
                }
            });
            return subs;
        };

        /**
         * 记录model和内部的所有model及collection的改变，增加变化的监听
         * @param _key
         * @param _model 被保存的对象, 如果后面的_listenedObject未定义, 则同时也是被监听的对象
         * @param _listenedObject 被监听的对象
         */
        DbRecorder.recordChange = function (_key, _model, _listenedObject) {
            var startTime = new Date().getTime();
            var key = _key || _model.id || _model.cid,
                model = _model,
                listenedObject = _listenedObject || _model;

            // 如果监听过，则不再处理
            if (listenedObject.listenedFlag && listenedObject.listenedFlag[key]) {
                return;
            }

            // flat需要监听的对象为一个array（包括这个被监听的对象自身都会被加到array），然后对其中的每个对象加监听
            _.each(self.search(listenedObject), function (m) {
                // 如果监听过, 或者ｍ本身就未定义，则不再处理
                if (!m || (m.listenedFlag && m.listenedFlag[key])) {
                    return;
                }

                if ((m instanceof Backbone.Model)) {
                    _.each(m.attributes, function (attributeValue, attributeName) {
                        //监听model里每一个attribute的变化, 如果改变就保存到storage
                        m.on("change:" + attributeName, function (submodel, value, options) {
                            self.save(key, model);
                            //如果改变后的属性值是Model或者Collection, 则也要对其进行监听
                            if (value && (value instanceof Backbone.Model || value instanceof Backbone.Collection)) {
                                self.recordChange(key, model, value);
                            }
                        });
                    })

                } else if (m instanceof Backbone.Collection) {
                    _.each(['add', 'reset', 'remove'], function (event) {
                        m.on(event, function () {
                            self.save(key, model);
                            //当一个collection发生改变时，对其中未被监听过的对象进行监听
                            m.each(function (elem) {
                                self.recordChange(key, model, elem);
                            });
                        });
                    });
                }

                //为对象加上已监听标志
                if (!m.listenedFlag) {
                    m.listenedFlag = {};
                }
                m.listenedFlag[key] = true;
            });

            var endTime = new Date().getTime();
            DbRecorder.submit_recordTime += (endTime - startTime);
        };

        /*
         * 将model写入storage
         * 这里面有一个2s的延迟，就是如果在2s内发生了多次change，只会记录最后一次
         * 从而提高js执行效率
         */
        DbRecorder.save = function (_key, _value, delay = 1000) {
            if (_value == null) {
                return;
            }

            if(_.isObject(_value)) {
                _value.valueSaved = false;
            }

            _.delay(function() {
                if (_value.valueSaved) {
                    // console.log("need not saving ");
                } else {
                    if(_.isObject(_value)) {
                        _value.valueSaved = true;
                    }
                    // console.log("DbRecorder.save() ", _key, _value);
                    const doc = self.convert2JSON(_value);
                    storage.setItem(_key, doc);
                }
            }, delay);
        };

        DbRecorder.saveNow = function (_key, _value) {
            DbRecorder.save(_key, _value, 0);
        };

        /**
         * defaults方法实现了一个深度defaults
         * @param defaults
         * @param object
         * @returns {*}
         */
        DbRecorder.defaults = function (defaults, object) {
            _.each(object, function (v, k) {
                if (defaults[k] === undefined) {
                    defaults[k] = v;
                } else if (_.isObject(defaults[k]) && _.isObject(v)) {
                    defaults[k] = self.defaults(defaults[k], v);
                }
            });
            return defaults;
        };

        return DbRecorder;
    })();
    var storage = (function () {
        var self = {}, temp = {};
        self.getItem = function (key) {
            if (window.localStorage) {
                try {
                    var value = window.localStorage.getItem(key);
                    if (value === null || value === 'undefined' || value === '') {
                        return value;
                    }
                    if (value.indexOf("{")>-1 && value.indexOf("}")>-1) {
                        return JSON.parse(value);
                    }
                    if (value.indexOf("[")>-1 && value.indexOf("]")>-1) {
                        return JSON.parse(value);
                    }
                    if (value.indexOf("\"") == 0 && value.match(/\"$/)) {
                        value = value.substring(1, value.length - 1);
                        return value;
                    }
                    return value;
                } catch (e) {
                    self.removeItem(key);
                    window.console.warn(e.message);
                    return null;
                }
            } else {
                //如果没有localStorage可以用cookie来做，因为我们只支持webkit，所以，目前不需要考虑对不对localStorage的支持
                //某种可能存在的极端的条件下（某些版本的ios，在隐身模式下，不支持localStorage）, 不存在localStorage，所以用temp
                //来取代
                return temp[key];
            }
        };
        self.setItem = function (key, value) {
            if (window.localStorage) {
                try {
                    window.localStorage.setItem(key, JSON.stringify(value));

                } catch (err) {
                    console.log(err);
                    temp[key] = value;
                }

            } else {
                temp[key] = value;
            }
        };
        self.removeItem = function (key) {
            if (window.localStorage) {
                window.localStorage.removeItem(key);
            } else {
                delete temp[key];
            }
        };
        return self;
    })();
    return recorder;
};

let exportedValue = main();
module.exports = exportedValue;



// WEBPACK FOOTER //
// ./src/recorder/DbRecorder.js